// extracted by mini-css-extract-plugin
module.exports = {"unnamed_resource":"unnamed_resource-j3EW6","team":"team-jaszr"};